import { render } from "./TheRechargesGenerals.vue?vue&type=template&id=a1f0b24a"
import script from "./TheRechargesGenerals.vue?vue&type=script&lang=js"
export * from "./TheRechargesGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__